import { useState } from 'react'

export const useModal = (initialModal = false): [boolean, () => void, () => void] => {
  const [isOpenModal, setIsOpenModal] = useState(initialModal)

  const openModal = (): void => {
    setIsOpenModal(true)
  }
  const closeModal = (): void => {
    setIsOpenModal(false)
  }

  return [isOpenModal, openModal, closeModal]
}
